import { isObject } from './isObject';

function omitBy(collection: Record<string, any>, predicate: (value: any, key: string) => unknown): Object {
  const newCollection: Record<string, any> = {};
  Object.entries(collection).forEach(([key, value]) => {
    if (predicate(value, key)) {
      return;
    }
    newCollection[key] = value;
  });
  return newCollection;
}

export function deepOmitBy(collection: any, predicate: (value: any, key: string | number) => unknown): object {
  if (Array.isArray(collection)) {
    let newCollection = Object.values(omitBy(collection, predicate));
    newCollection.forEach((value, index) => {
      newCollection[index] = deepOmitBy(value, predicate);
    });
    return newCollection;
  } else if (isObject(collection)) {
    let newCollection: Record<string, any> = omitBy(collection, predicate);
    Object.entries(collection).forEach(([key, value]) => {
      if (predicate(value, key)) {
        return;
      }
      newCollection[key] = deepOmitBy(value, predicate);
    });
    return newCollection;
  }

  return collection;
}
